<template>
  <img :src="src" alt="" class="ds-chevron" aria-hidden="true">
</template>

<script setup lang="ts">
import { computed } from 'vue'

/**
 * Chevron de navegación (Figma: chevron_right 24x24).
 *
 * `tone` elige el asset según el fondo sobre el que se dibuja:
 * - `dark`: para superficies claras (gris oscuro)
 * - `light`: para superficies oscuras (gris claro)
 */
const props = withDefaults(defineProps<{
  tone?: 'dark' | 'light'
}>(), {
  tone: 'dark'
})

const iconos = {
  dark: new URL('../../../assets/ds/ic_chevron.svg', import.meta.url).href,
  light: new URL('../../../assets/ds/ic_chevron_light.svg', import.meta.url).href
}

const src = computed(() => iconos[props.tone])
</script>

<style scoped>
/* Tamaño nativo del SVG: escalarlo lo deforma. */
.ds-chevron {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
}
</style>
